import React from "react";
import axios from "@/lib/axios";
import { useNavigate } from "react-router-dom";
import Footer from "../../welcome/components/Footer";
import Header from "../components/Header";
import Main from "../components/Main";

const Consent: React.FC = () => {
  const navigate = useNavigate();

  const handleAgree = async () => {
    try {
      const response = await axios.post('/facility/consents');
      if (response.status === 201) {
        navigate('/facility/welcome');
      }
    } catch (error) {
      console.error('Error creating consent:', error);
      alert('同意の処理中にエラーが発生しました。');
    }
  };


  return (
    <React.Fragment>
      <Header />
      <Main onAgree={handleAgree} />
      <Footer />
    </React.Fragment>
  )
}

export default Consent;